import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    margin: theme.spacing(3),
    alignItems: 'center',
  },
  txHeader: {
    fontSize: 20,
    fontWeight: 'bold',
    marginRight: 8,
  },
  txHead: {
    color: theme.palette.primary.main,
    fontSize: 14,
    paddingBottom: theme.spacing(1),
  },
  tFooter: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
}))

export default useStyles
